import { showCustomToast } from 'common/components/CustomToast/utils';
import { useMutation } from '@apollo/client';
import { ActionMessageModal } from 'common/components/ActionMessageModal';
import { EntityDeleteInput } from 'common/types/globalTypes';
import { EntityAction, EntityType } from 'common/types/utility';
import React from 'react';

import { CorporateWorkGroupsItem } from '..';
import {
  CorporateWorkgroupDelete,
  CorporateWorkgroupDeleteVariables,
} from '../../__generated__/CorporateWorkgroupDelete';
import CORPORATE_WORKGROUP_DELETE from '../../CorporateWorkgroupDelete.graphql';

interface DeleteWorkGroupProps {
  selectedRows: CorporateWorkGroupsItem[];
}

export const DeleteWorkGroup: React.FC<DeleteWorkGroupProps> = ({
  selectedRows,
}) => {
  const [deleteCorporateWorkgroup] = useMutation<
    CorporateWorkgroupDelete,
    CorporateWorkgroupDeleteVariables
  >(CORPORATE_WORKGROUP_DELETE, { errorPolicy: 'all' });

  const _onConfirm = async () => {
    const selectedData: CorporateWorkGroupsItem[] = selectedRows;
    const deletedRows: CorporateWorkGroupsItem[] = selectedData.filter(
      (item) => item._isDeletable
    );
    const entityDelete: EntityDeleteInput[] = selectedData
      .filter((item) => item._isDeletable)
      .map((item) => {
        return { id: item.id, rowTimestamp: item._rowTimestamp! };
      });
    const { errors } = await deleteCorporateWorkgroup({
      variables: {
        input: {
          entityDelete,
        },
      },
      update(cache) {
        deletedRows.forEach((item) => {
          const identity = cache.identify({
            ...item,
          });
          cache.evict({ id: identity });
          cache.gc();
        });
      },
    });
    if (errors?.length)
      showCustomToast({
        content: errors[0].message,
        appearance: 'error',
      });
    else {
      showCustomToast({
        content: 'Record deleted successfully.',
        appearance: 'success',
      });
    }
  };

  return (
    <ActionMessageModal
      entityType={EntityType.WorkGroup}
      action={EntityAction.Remove}
      disabled={!selectedRows.some((selected) => selected._isDeletable)}
      visible={!!selectedRows.length}
      multiple={{
        validCount: selectedRows.filter((selected) => selected._isDeletable)
          .length,
        invalidNames: selectedRows
          .filter((selected) => !selected._isDeletable)
          .map((selected) => selected.workgroupNumber || ''),
      }}
      onConfirm={_onConfirm}
    />
  );
};
